module.exports = __webpack_public_path__ + "static/img/shanchu.28a3eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/shanchu.png
// module id = j2Mt
// module chunks = 24